export default function (value) {
    if (!value) {
        return '';
    }

    return value.split('</p>')[0].split('>').slice(1).join('>');
}
